import { motion } from "framer-motion";
import { FaBolt, FaLock, FaHandshake, FaEye, FaSmile, FaSlidersH } from "react-icons/fa";
import "./WhyChooseUs.css";

const blocks = [
  {
    icon: FaBolt,
    title: "Fast Processing",
    desc: "From application to disbursal, our streamlined process gets you funds without unnecessary delay.",
  },
  {
    icon: FaLock,
    title: "Secure Transactions",
    desc: "Your gold, documents, and data are handled with bank-grade security at every step.",
  },
  {
    icon: FaHandshake,
    title: "Trusted Service",
    desc: "A decade of service built on honest relationships with thousands of families and businesses.",
  },
  {
    icon: FaEye,
    title: "Transparent Policies",
    desc: "Clear terms, upfront rates, and no hidden charges — what you see is what you pay.",
  },
  {
    icon: FaSmile,
    title: "Customer Satisfaction",
    desc: "Dedicated support that puts your convenience and confidence first.",
  },
  {
    icon: FaSlidersH,
    title: "Flexible Loan Options",
    desc: "Loan structures tailored to fit your income cycle and repayment comfort.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="section lf-why">
      <div className="container">
        <div className="section-head-center">
          <span className="eyebrow">Why LENT FINANCE</span>
          <h2 className="section-heading">
            Built On <span className="accent-text">Trust</span> &amp; Transparency
          </h2>
          <p className="section-subtext">
            The reasons our customers keep coming back — and keep referring us.
          </p>
        </div>

        <div className="lf-why__list">
          {blocks.map(({ icon: Icon, title, desc }, i) => {
            const fromLeft = i % 2 === 0;
            return (
              <motion.div
                key={title}
                className={`lf-why__row ${fromLeft ? "lf-why__row--left" : "lf-why__row--right"}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.4 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              >
                <div className="lf-why__icon-wrap">
                  <span className="lf-why__icon">
                    <Icon />
                  </span>
                </div>
                <div className="lf-why__text">
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
